var _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChangeTypeEmoji(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 106,
    viewBox: "0 0 98 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_9870_8367)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 10,
    width: 64,
    height: 64,
    rx: 32,
    fill: "url(#paint0_linear_9870_8367)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 9,
    width: 66,
    height: 66,
    rx: 33,
    stroke: "white",
    strokeWidth: 2,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9870_8367)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49 58C57.8366 58 65 50.8366 65 42C65 33.1634 57.8366 26 49 26C40.1634 26 33 33.1634 33 42C33 50.8366 40.1634 58 49 58Z",
    fill: "#FFD93B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0019 41.9999C65.0019 50.8399 57.8369 57.9999 49.0019 57.9999C43.9719 57.9999 39.4819 55.6799 36.5469 52.0449C39.2919 54.2649 42.7869 55.5899 46.5919 55.5899C55.4269 55.5899 62.5919 48.4299 62.5919 39.5899C62.5919 35.7849 61.2669 32.2899 59.0469 29.5449C62.6769 32.4799 65.0019 36.9699 65.0019 41.9999Z",
    fill: "#F4C534"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3847 39.8485C48.6107 42.6525 46.9797 44.9245 44.7407 44.9245C42.5027 44.9245 40.5047 42.6515 40.2787 39.8485C40.0527 37.0445 41.6837 34.7725 43.9217 34.7725C46.1597 34.7725 48.1587 37.0445 48.3847 39.8485Z",
    fill: "#F4C534"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.697 39.8517C47.697 42.2867 46.189 44.2677 44.323 44.2677C42.465 44.2677 40.957 42.2867 40.957 39.8517C40.957 37.4077 42.465 35.4277 44.323 35.4277C46.19 35.4267 47.697 37.4077 47.697 39.8517Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6832 42.7278C46.0098 42.7278 47.0852 41.4845 47.0852 39.9508C47.0852 38.4171 46.0098 37.1738 44.6832 37.1738C43.3567 37.1738 42.2812 38.4171 42.2812 39.9508C42.2812 41.4845 43.3567 42.7278 44.6832 42.7278Z",
    fill: "#3E4347"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2398 38.0461C43.9563 37.8789 43.5324 38.0724 43.2932 38.4782C43.0539 38.884 43.0898 39.3485 43.3733 39.5157C43.6569 39.6828 44.0807 39.4894 44.32 39.0836C44.5592 38.6778 44.5233 38.2133 44.2398 38.0461Z",
    fill: "#5A5F63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.364 36.3919C39.303 36.3499 42.947 31.8329 46.315 33.2989C45.2 31.3059 42.239 29.9139 39.364 36.3919Z",
    fill: "#3E4347"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.6186 39.8494C49.3926 42.6534 51.0236 44.9254 53.2626 44.9254C55.5006 44.9254 57.4986 42.6524 57.7246 39.8494C57.9506 37.0454 56.3196 34.7734 54.0816 34.7734C51.8426 34.7724 49.8446 37.0454 49.6186 39.8494Z",
    fill: "#F4C534"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3008 39.8517C50.3008 42.2867 51.8088 44.2677 53.6748 44.2677C55.5328 44.2677 57.0408 42.2867 57.0408 39.8517C57.0408 37.4077 55.5328 35.4277 53.6748 35.4277C51.8088 35.4267 50.3008 37.4077 50.3008 39.8517Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3161 42.7278C54.6426 42.7278 55.7181 41.4845 55.7181 39.9508C55.7181 38.4171 54.6426 37.1738 53.3161 37.1738C51.9895 37.1738 50.9141 38.4171 50.9141 39.9508C50.9141 41.4845 51.9895 42.7278 53.3161 42.7278Z",
    fill: "#3E4347"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7031 38.4792C54.4639 38.0733 54.0401 37.8798 53.7565 38.047C53.4729 38.2141 53.437 38.6786 53.6762 39.0845C53.9154 39.4903 54.3393 39.6838 54.6228 39.5167C54.9064 39.3495 54.9424 38.885 54.7031 38.4792Z",
    fill: "#5A5F63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6346 36.3919C58.6956 36.3499 55.0516 31.8329 51.6836 33.2989C52.7986 31.3059 55.7596 29.9139 58.6346 36.3919Z",
    fill: "#3E4347"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2373 54.8983C49.8453 55.4953 47.9503 55.5303 45.4073 54.8583C45.1113 52.2663 45.4873 49.3083 46.1273 46.8283C48.5223 46.3643 49.8183 46.4813 51.5373 46.7983C52.6803 49.7693 53.0993 51.8803 52.2373 54.8983Z",
    fill: "#3E4347"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1251 54.3262C51.2071 53.8832 51.2531 53.5022 51.2531 53.2872C51.2531 52.4542 50.5821 51.7832 49.7491 51.7832C49.3901 51.7832 49.0651 51.9122 48.8071 52.1222C48.5901 52.0002 48.3461 51.9332 48.0821 51.9332C47.2491 51.9332 46.5781 52.6032 46.5781 53.4372C46.5781 53.6282 46.6151 53.9492 46.6791 54.3272H51.1251V54.3262Z",
    fill: "#E24B4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5282 48.2314C51.4192 47.9054 51.3002 47.5744 51.1702 47.2384C49.6262 46.9404 48.0832 46.9454 46.5392 47.2534C46.4622 47.5904 46.3912 47.9254 46.3242 48.2584C48.0592 48.4184 49.7942 48.4114 51.5282 48.2314Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8242 53.7898C45.8352 54.0158 45.8482 54.2408 45.8692 54.4648C47.8592 54.9758 49.8492 54.9828 51.8392 54.4848C51.9082 54.2458 51.9572 54.0098 52.0062 53.7748C49.9452 53.5568 47.8842 53.5598 45.8242 53.7898Z",
    fill: "white"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.256 101.24C3.056 101.24 0.576 98.632 0.576 95.24C0.576 91.864 3.056 89.272 6.256 89.272C9.136 89.272 11.44 91.192 11.872 94.024H10C9.68 92.168 8.176 90.856 6.272 90.856C4 90.856 2.4 92.696 2.4 95.24C2.4 97.816 4 99.656 6.272 99.656C8.176 99.656 9.68 98.328 10 96.472H11.872C11.44 99.32 9.136 101.24 6.256 101.24ZM15.1891 96.216V101H13.5731V89.512H15.1891V93.88C15.7491 92.968 16.6131 92.36 17.7811 92.36C19.5251 92.36 20.6771 93.48 20.6771 95.512V101H19.0611V96.056C19.0611 94.6 18.4211 93.784 17.2211 93.784C16.1171 93.784 15.1891 94.712 15.1891 96.216ZM27.9591 101V99.688C27.4311 100.632 26.4871 101.16 25.2391 101.16C23.4791 101.16 22.3271 100.152 22.3271 98.6C22.3271 96.936 23.6551 96.072 26.1831 96.072C26.6791 96.072 27.0791 96.088 27.7671 96.168V95.544C27.7671 94.328 27.1111 93.64 25.9911 93.64C24.8071 93.64 24.0871 94.344 24.0391 95.528H22.5671C22.6471 93.624 24.0071 92.36 25.9911 92.36C28.0871 92.36 29.3031 93.544 29.3031 95.56V101H27.9591ZM23.8631 98.552C23.8631 99.432 24.5191 100.008 25.5591 100.008C26.9191 100.008 27.7671 99.16 27.7671 97.864V97.176C27.1431 97.096 26.6951 97.08 26.2791 97.08C24.6631 97.08 23.8631 97.56 23.8631 98.552ZM33.0798 96.216V101H31.4638V92.52H32.9678V93.928C33.5438 92.984 34.5038 92.36 35.6718 92.36C37.4158 92.36 38.5677 93.48 38.5677 95.512V101H36.9518V96.056C36.9518 94.6 36.3118 93.784 35.1118 93.784C34.0078 93.784 33.0798 94.712 33.0798 96.216ZM44.1058 104.264C41.8818 104.264 40.4418 103.08 40.3458 101.16H41.9138C42.0098 102.344 42.7778 102.984 44.0898 102.984C45.5458 102.984 46.3138 102.2 46.3138 100.744V99.208C45.8338 100.232 44.8738 100.824 43.7218 100.824C41.6098 100.824 40.1058 99.08 40.1058 96.584C40.1058 94.056 41.5458 92.36 43.6738 92.36C44.8898 92.36 45.8498 92.952 46.4258 94.024V92.52H47.9298V100.712C47.9298 102.936 46.5058 104.264 44.1058 104.264ZM41.7378 96.584C41.7378 98.344 42.6018 99.416 44.0098 99.416C45.3858 99.416 46.3138 98.312 46.3138 96.632C46.3138 94.872 45.4018 93.752 44.0098 93.752C42.6178 93.752 41.7378 94.84 41.7378 96.584ZM53.6549 101.16C51.2069 101.16 49.5589 99.384 49.5589 96.712C49.5589 94.2 51.2709 92.36 53.6069 92.36C56.1349 92.36 57.8149 94.408 57.5269 97.16H51.2069C51.3349 98.888 52.1989 99.896 53.6229 99.896C54.8229 99.896 55.6549 99.24 55.9269 98.136H57.5269C57.1109 100.024 55.6549 101.16 53.6549 101.16ZM53.5749 93.576C52.2789 93.576 51.3989 94.504 51.2229 96.088H55.8149C55.7349 94.52 54.8869 93.576 53.5749 93.576ZM67.2768 101H65.5168V91.096H61.7728V89.512H71.0208V91.096H67.2768V101ZM79.0819 92.52L74.8419 104.088H73.0819L74.2979 100.888L70.9539 92.52H72.6979L75.1619 98.984L77.4499 92.52H79.0819ZM88.3254 96.76C88.3254 99.32 86.8534 101.16 84.5814 101.16C83.4294 101.16 82.4534 100.584 81.8454 99.56V104.088H80.2294V92.52H81.7334V94.072C82.3414 92.984 83.3814 92.36 84.5814 92.36C86.8374 92.36 88.3254 94.2 88.3254 96.76ZM86.6454 96.76C86.6454 94.856 85.6374 93.784 84.2454 93.784C82.9014 93.784 81.8454 94.856 81.8454 96.76C81.8454 98.632 82.8854 99.72 84.2454 99.72C85.6374 99.72 86.6454 98.664 86.6454 96.76ZM93.4518 101.16C91.0038 101.16 89.3558 99.384 89.3558 96.712C89.3558 94.2 91.0678 92.36 93.4038 92.36C95.9318 92.36 97.6118 94.408 97.3238 97.16H91.0038C91.1318 98.888 91.9958 99.896 93.4198 99.896C94.6198 99.896 95.4518 99.24 95.7238 98.136H97.3238C96.9078 100.024 95.4518 101.16 93.4518 101.16ZM93.3718 93.576C92.0758 93.576 91.1957 94.504 91.0198 96.088H95.6118C95.5318 94.52 94.6838 93.576 93.3718 93.576Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_9870_8367",
    x: 5,
    y: 0,
    width: 88,
    height: 88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.8 0 0 0 0 0.647059 0 0 0 0 0.941176 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9870_8367"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_9870_8367",
    result: "effect2_dropShadow_9870_8367"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_9870_8367",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9870_8367",
    x1: 57.2249,
    y1: 148,
    x2: 29.3265,
    y2: 1.24471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32D1E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C63CF9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9870_8367"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(33 26)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeTypeEmoji);
export default __webpack_public_path__ + "static/media/change_type_emoji.157791c21037e303af11311d7d806156.svg";
export { ForwardRef as ReactComponent };